// src/components/ThemeToggle.jsx
import { motion } from 'framer-motion';
import useTheme from '../context/ThemeContext';

export const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      whileTap={{ scale: 0.9 }}
      whileHover={{ scale: 1.1 }}
      style={{
        width: '50px',
        height: '26px',
        background: isDark ? '#4f46e5' : '#cbd5e1',
        borderRadius: '13px',
        border: 'none',
        cursor: 'pointer',
        padding: '3px',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        transition: 'background 0.3s',
      }}
    >
      <motion.div
        layout
        transition={{
          type: 'spring',
          stiffness: 700,
          damping: 30,
        }}
        style={{
          width: '20px',
          height: '20px',
          background: 'white',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          marginLeft: isDark ? '24px' : '0px',
        }}
      >
        <motion.i
          key={isDark ? 'moon' : 'sun'}
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          exit={{ scale: 0, rotate: 180 }}
          className={isDark ? 'fas fa-moon' : 'fas fa-sun'}
          style={{
            color: isDark ? '#4f46e5' : '#f59e0b',
            fontSize: '10px',
          }}
        />
      </motion.div>
    </motion.button>
  );
};

export default ThemeToggle;